module.exports = __webpack_public_path__ + "img/launchpad-banner-bg-sm.8e704cfc.png";